<div class="app-classroom-course" *ngIf="classroomCourse">
 <div class="slider-banner">
    <div ngImagePixel #bannermageHolder="imagePixel" class="banner-item">
      <img
          class="img-fluid"
          src="{{ getDefaultMedia(classroomCourse)?.url }}?{{
            bannermageHolder.imagePixel
          }}&&dpr=2&{{ bannermageHolder.aspectRation }}&fit=crop&auto=compress"
          alt="banner-image"
        />

      <div class="carousel-caption">
        <div class="container">
          <div class="container position-absolute back-button-container">
            <button appGoBack
               [paramId]="!classroomCourse.isWebinar && classroomCourse.id"
               [latitude]="!classroomCourse.isWebinar && classroomCourse.position.lat"
               [longitude]="!classroomCourse.isWebinar && classroomCourse.position.lon"
               mat-button
               [disableRipple]="true"
               class="back-button position-absolute text-white">
              <mat-icon>west</mat-icon>
            </button>
          </div>
          <div class="row justify-content-between">
            <div
              class="col-12 col-sm-12 col-md-9 col-lg-7 col-xl-6 text-left order-1 order-md-0"
            >
              <h6 class="h6 text-uppercase">{{translationScope+'.titles.course' | transloco}}</h6>
              <h1 class="h1">{{ classroomCourse.title }}</h1>
              <div class="card-rating" *ngIf="classroomCourse?.rating > 0">
                <div class="rating">
                  <ngx-show-rating color="#ffffff" [rate]="classroomCourse?.rating" [max]="5"></ngx-show-rating>
                  <span *ngIf="classroomCourse.rating > 0">{{ classroomCourse?.rating | number:'1.1-1' }}</span>
                  <span *ngIf="classroomCourse.rating <= 0">0</span>
                </div>
              </div>
              <div class="btn-info-group">
                <span
                  class="badge badge-primary"
                  style="cursor: pointer"
                  (click)="onClickLocation(classroomCourse)"
                >
                  <img class="map-pin-icon" alt="Pin" />
                  <ng-container *ngIf="!classroomCourse.isWebinar; else showWebinar" >
                    {{ classroomCourse.address.city }}, {{ classroomCourse.regions[0].name }}
                  </ng-container>
                   <ng-template #showWebinar>
                     Webinar
                   </ng-template>
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <section class="main-content">
    <div class="container">
      <div class="row">
        <div class=" col-12 col-sm-12 col-md-12 col-lg-6 order-last order-sm-last order-md-last order-lg-first">
          <div  class="section-item">
            <div class="section-title" style="margin-top: 42px;">
              <h4 class="h4 mt-3">{{ classroomCourse.isWebinar ? 'Webinar' : (translationScope+'.titles.place' | transloco)}}</h4>
            </div>
            <p class="pragraph mt-3">
              <ng-container *ngIf="!classroomCourse.isWebinar" >
                {{ classroomCourse.address.city }}, {{ classroomCourse.regions[0].name }}
              </ng-container>
            </p>
          </div>
          <div class="section-item">
            <app-readmore-description [descriptionTitle]="translationScope+'.titles.about_course' | transloco" [description]="classroomCourse.about"></app-readmore-description>
          </div>
          <div class="section-item" *ngIf="instructor$ | async">
            <app-instructor-card class="d-block" [instructor]="instructor$ | async"></app-instructor-card>
          </div>
          <div class="section-item">
            <app-readmore-description [descriptionTitle]="translationScope+'.titles.course_content' | transloco" [description]="(template$ | async)?.content"></app-readmore-description>
          </div>
          <div class="section-item">
            <app-readmore-description [descriptionTitle]="translationScope+'.titles.target_group' | transloco" [description]="(template$ | async)?.targetGroup"></app-readmore-description>
          </div>
          <div class="section-item">
            <app-course-pictures [mediaTitle]="translationScope+'.titles.course_images' | transloco" [medias]="classroomCourse.media"></app-course-pictures>
          </div>
          <div class="section-item">
            <app-readmore-description [descriptionTitle]="translationScope+'.titles.practical_information' | transloco" [description]="(template$ | async)?.information"></app-readmore-description>
          </div>

          <div class="section-item"  *ngIf="reviews.length">
            <app-course-reviews
                [course]="classroomCourse"
                [reviews]="reviews"
                [reviewTotalCount]="reviewTotalCount">
              </app-course-reviews>
          </div>
          <div class="section-item">
            <app-readmore-description [descriptionTitle]="translationScope+'.titles.curriculum' | transloco" [description]="(template$ | async)?.cirriculum"></app-readmore-description>
          </div>

          <div *ngIf="!classroomCourse.isWebinar" class="section-item">
            <div class="section-title" style="margin-top: 42px;">
              <h4 class="h4 mt-3">{{translationScope+'.titles.meetup_place' | transloco}}</h4>
            </div>
            <p class="pragraph mt-3">
              {{ classroomCourse.address.streetAddress }}
              <br/>
              <span class="mt-2">{{ classroomCourse.location }}</span>
            </p>

              <mapbox-map-direction
                 *ngIf="!classroomCourse.isWebinar"
                [destination]="classroomCourse?.position ? { lat: classroomCourse?.position?.lat, lon: classroomCourse?.position?.lon }: null">
              </mapbox-map-direction>
          </div>
        </div>
        <div
          class="
            col-12 col-sm-12 col-md-12 col-lg-6
            offset-lg-0
            col-xl-5
            offset-xl-1
            order-first order-sm-first order-md-first order-lg-last
            float-right
          "
        >
          <div class="request-guide-form" id="request-guide-form">
            <div class="calendar-wrapper">
              <app-classroom-schedules
                [schedules]="availability$ | async"
                [multipleParticipant]="multipleParticipant"
                [numberOfParticipant]="numberOfParticipant"
                [classroom]="classroomCourse"
                [instructor]="instructor$ | async"
                (onSelectedSchedule)="onSelectedSchedule($event)">
              </app-classroom-schedules>
            </div>

            <!-- <div class="time-button-wrapper" >
              <ng-container *ngIf="selectedSchedule">
                <ng-container *ngIf="!selectedSchedule.isSignUpDateExpired; else signupDateExpire">
                  <h6
                  class="booking-title"
                  *ngIf="seats >= 4; else fewTimeSlots">
                  {{seats}} {{translationScope+'.more_free_seats' | transloco}}
                </h6>
                </ng-container>
              </ng-container>

              <ng-template #fewTimeSlots>
                <h6
                  class="booking-title"
                  *ngIf="seats < 4 && seats >= 2; else oneTimeSlot">
                  {{seats}} {{translationScope+'.free_seats' | transloco}}
                </h6>
              </ng-template>
              <ng-template #oneTimeSlot>
                <h6
                  class="booking-title"
                  *ngIf="seats == 1; else noTimeSlot">
                  {{seats}} {{translationScope+'.free_seat' | transloco}}
                </h6>
              </ng-template>
              <ng-template #noTimeSlot>
                <h6 class="booking-title sold-out">{{translationScope+'.sold_out' | transloco}}</h6>
              </ng-template>

              <ng-template #signupDateExpire>
                <h6 class="booking-title">{{translationScope+'.signup_deadline_passed' | transloco}}</h6>
              </ng-template>

            </div> -->

            <!-- <div class="multi-booking-wrapper" *ngIf="seats > 0">
              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input
                    [formControl]="multipleParticipant"
                    type="checkbox"
                    class="custom-control-input"
                    id="multi-booking"
                    name="multi-booking"
                  />
                  <label class="custom-control-label" for="multi-booking">
                    {{translationScope+'.check_multi_participant' | transloco}}
                  </label>
                </div>

                <div class="mt-3" *ngIf="multipleParticipant.value">
                  <div class="custom-input-group-label">
                    {{translationScope+'.select_participant' | transloco}}
                  </div>

                  <div class="custom-input-group">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button (click)="decreaseParticipant()" class="btn btn-outline-primary" type="button">-</button>
                      </div>
                      <input type="number"
                        class="form-control text-center"
                        [formControl]="numberOfParticipant"
                        placeholder="0"
                        aria-label="participants"
                        aria-describedby="number-of-participants">
                      <div class="input-group-append">
                        <button (click)="increaseParticipant()" class="btn btn-outline-primary" type="button">+</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div> -->

            <div class="multi-booking-wrapper" *ngIf="multipleParticipant">
              <p class="multi-booking-info">{{translationScope+'.check_multi_participant' | transloco: {count: numberOfParticipant} }}</p>
            </div>

            <div class="price-wrapper">
              <h6 class="booking-title">
                <!-- {{ getPricingType(experience) }} -->
              </h6>
              <div class="row">
                <div *ngIf="classroomCourse.pricePerMember > 0" class="col-6">
                  <div class="price-wrapper">
                    <div class="price-title">{{translationScope+'.rs_member' | transloco}}</div>
                    <div class="price-count">
                      <span data-pvalue="1290" class="price-value">{{ classroomCourse.pricePerMember }}</span>
                      <sup>NOK</sup>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="price-wrapper">
                    <div class="price-title">{{translationScope+'.rs_non_member' | transloco}}</div>
                    <div class="price-count">
                      <span data-pvalue="1290" class="price-value">{{ classroomCourse.pricePerStudent }}</span>
                      <sup>NOK</sup>
                    </div>
                  </div>
                </div>

                <div class="col-12 mt-3">
                  <button class="btn btn-clear" (click)="rsMember()">
                    <span class="text-uppercase">{{translationScope+'.become_rs_member' | transloco}}</span>
                    <div class="icon"><i class="fas fa-arrow-right"></i></div>
                  </button>
                </div>

                <div class="col-12 mt-3">
                  <div class="price-wrapper">
                    <div class="price-title text-uppercase">{{translationScope+'.course_days' | transloco}}</div>
                    <div class="price-count">
                      <span data-pvalue="1290" class="price-value">{{ classroomCourse.duration }}</span>
                      <sup *ngIf="classroomCourse.duration === 1; else severalDays">{{translationScope+'.day' | transloco}}</sup>
                      <ng-template #severalDays>
                        <sup>{{translationScope+'.days' | transloco}}</sup>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <ng-container *ngIf="userInfo$ | async as user; else annonymous">
              <button
                [disabled]="
                  (instructor$ | async)?.userId === user.sub || seats <=0 || selectedSchedule == null || selectedSchedule.isSignUpDateExpired
                "
                (click)="requestBooking(user)"
                class="btn btn-primary form-control">
                <b class="text-uppercase">{{translationScope+'.action_buttons.buy' | transloco}}</b>
              </button>
            </ng-container>

            <ng-template #annonymous>
              <button
                [disabled]="seats <= 0 || selectedSchedule == null || selectedSchedule.isSignUpDateExpired"
                (click)="requestBooking(null)"
                class="btn btn-primary form-control">
                <b class="text-uppercase">{{translationScope+'.action_buttons.buy' | transloco}}</b>
              </button>
            </ng-template> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
